export enum LayoutDirection {
    TopToBottom = 'TB',
    LeftToRight = 'LR',
    RightToLeft = 'RL',
    BottomToTop = 'BT',
}
